import { Component, OnChanges, inject, ChangeDetectionStrategy, signal, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-horizontal-mechanical-connections',
    templateUrl: './horizontal-mechanical-connections.component.html',
    styleUrls: ['./horizontal-mechanical-connections.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class HorizontalMechanicalConnectionsComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly imagePrefix = input.required<string>();
  readonly valueChanged = output<void>();
  handArrangementSelection!: GuruEntity;
  paintOptionsSelection!: GuruEntity;
  returnAirStyleSelection!: GuruEntity;
  supplyAirOptionSelection!: GuruEntity;
  outsideAirSelection!: GuruEntity;
  sameSidePipingSelection!: GuruEntity;
  readonly handArrangementImagePath = signal<string>(undefined!);
  isExpanded = true;
  private sectionKey = ConfigurationSection.MECHANICAL_CONNECTIONS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.handArrangementSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHandArrangment');
    this.paintOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPaintOptions');
    this.returnAirStyleSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USReturnAirOptions');
    this.supplyAirOptionSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyAirOptions');
    this.outsideAirSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USOutsideAir');
    this.sameSidePipingSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSameSidePipingCtrls');
    this.modelService.executeHierarchy(this.engineKey(), 'hierDOC').subscribe(() => {
      this.modelService.getCharacteristicValue(this.engineKey(), 'UnitHandArrangementImage', 'FileName').subscribe(result => {
        this.handArrangementImagePath.set(this.imagePrefix() + result);
      });
    });
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
